import axios from "axios";
import { API } from "@/auth";
import { getAuthToken } from "./authToken";

export const api = axios.create({ baseURL: API });
api.interceptors.request.use(cfg => {
  const t = getAuthToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function waLink(text) {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

export function fmtINR(n) {
  if (n === null || n === undefined) return "—";
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);
}

export function daysSince(iso) {
  if (!iso) return 0;
  return Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
}
